import { JetView } from 'webix-jet';

/**
 * PricesView class extends JetView to create a view for displaying prices.
 */
export default class PricesView extends JetView {
    /**
     * Configures the view with specific settings.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        return {
            css: 'ifr_template', // CSS class for styling the iframe
            view: 'iframe', // Defines the view type as an iframe
            on: {
                /**
                 * Event triggered after the iframe has loaded.
                 */
                onAfterLoad() {
                    try {
                        // Hides specific elements in the iframe's document
                        this.getWindow().document.querySelector('.global-header').style.display = 'none';
                        this.getWindow().document.querySelector('.licenses-info-section').style.display = 'none';
                        this.getWindow().document.querySelector('.section-info-row-get-start').style.display = 'none';
                        this.getWindow().document.querySelector('.global-footer-wrap').style.display = 'none';
                    } catch (err) {
                        // Error handling for potential issues in accessing iframe elements
                    }
                    if (this.hideProgress) this.hideProgress(); // Hides the progress indicator if applicable
                    this.enable(); // Enables the view after loading
                },
            },
        };
    }

    /**
     * Initializes the view by extending it with a progress bar and loading content.
     * @param {Object} view - The view instance to initialize.
     */
    init(view) {
        webix.extend(view, webix.ProgressBar); // Extends the view with a progress bar functionality
        view.disable(); // Disables the view initially
        view.showProgress({ type: 'icon' }); // Shows a progress indicator of type 'icon'
        view.load('https://webix.com/licenses/'); // Loads content from the specified URL
    }
}

// FILE DOCUMENTED
